import { render, staticRenderFns } from "./AuthorsContainer.vue?vue&type=template&id=1ec0ca1d&"
import script from "./AuthorsContainer.vue?vue&type=script&lang=js&"
export * from "./AuthorsContainer.vue?vue&type=script&lang=js&"
import style0 from "./AuthorsContainer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports